import type {AxiosResponse} from "axios";

import CoreApi from "@/src/modules/core/api";
import type {GetResponse} from "@/src/modules/core/types";

import type {
  PanicButtonSettingsCatalog,
  PanicButtonSettingsResponse,
  PanicButtonSettingsUpdatePayload,
} from "../types";

class PanicButtonSettingsApi extends CoreApi {
  getCreate(companyId: number): Promise<AxiosResponse<GetResponse<PanicButtonSettingsCatalog>>> {
    return this.get(`companies/${companyId}/panic-button-settings/create`);
  }

  getSettings(companyId: number): Promise<AxiosResponse<GetResponse<PanicButtonSettingsResponse>>> {
    return this.get(`companies/${companyId}/panic-button-settings`);
  }

  updateSettings(
    companyId: number,
    data: PanicButtonSettingsUpdatePayload,
  ): Promise<AxiosResponse<GetResponse<PanicButtonSettingsResponse>>> {
    return super.update(`companies/${companyId}/panic-button-settings`, "", data);
  }
}

export const panicButtonSettingsApi = new PanicButtonSettingsApi();
